import { ConsentStore } from '@mfe-4cs/state/ConsentStore';
import { FeatureValueStore } from '@mfe-4cs/state/FeatureValueStore';
import { customElement, property } from 'lit/decorators.js';
import { comsStore } from '@mfe-4cs/state/ComsStore';
import { LitElement } from 'lit';
import { TemplatingMixin } from '@mfec/lit/mixins/TemplatingMixin';
import { Theme } from '@mfec/types/enum';
import { templates } from './templates'; // eslint-disable-line import/no-cycle

@customElement('tef-coms-tri-state-button')
export class TefComsTriStateButton extends TemplatingMixin(LitElement, Theme.OCCL, templates) {
  @property({ type: Object }) consent!: ConsentStore | FeatureValueStore;
  @property({ type: Boolean, attribute: false }) deprecated?: boolean; // attribute: false -> can be also undefined
  @property({ type: Boolean, attribute: false }) checked?: boolean;

  buttonType = '';
  isDeprecated: boolean | undefined = false;

  connectedCallback() {
    if (typeof super.connectedCallback !== 'undefined') super.connectedCallback();
    this.isDeprecated = this.consent instanceof ConsentStore ? this.consent.deprecated : this.deprecated;
  }

  async firstUpdated() {
    await this.updateComplete;
  }

  get variant() {
    if (this.buttonType === 'granted') return this.consent.granted ? 'solid' : 'outline';
    return this.consent.granted === false ? 'solid' : 'outline';
  }

  get color() {
    if (this.consent.granted === undefined) return '';
    return this.buttonType === 'granted' ? 'positive' : 'negative';
  }

  get icon() {
    return this.buttonType === 'granted' ? 'check' : 'cancel';
  }

  get disabled() {
    return (comsStore.identity?.readonly || this.isDeprecated) ?? false;
  }

  handleClick(type: string) {
    if (typeof this.consent.granted === 'undefined') {
      this.consent.change(type === 'granted');
    } else {
      this.consent.change(!this.consent.granted);
    }
    this.requestUpdate();
  }

  createButton(type: 'granted' | 'revoked') {
    this.buttonType = type;
    const buttonType = type === 'granted';

    return this.getTemplateFn('triStateButtonsPartTemplate')(buttonType, type);
  }

  override render() {
    return this.getTemplateFn('triStateButtonTemplate')();
  }

  // Render into lightDOM
  protected createRenderRoot() {
    return this;
  }
}
